// Módulo para inicializaciones pesadas que se cargan solo cuando se necesitan
// Esto mejora el tiempo de carga inicial de la aplicación

// Pool de listeners para WebSocket - inicializado solo cuando se necesita
const LISTENER_POOL_SIZE = 30;
let listenerPool: Array<{
  id: number;
  isBusy: boolean;
  assignedDevice: number | null;
  listener: ((data: any) => void) | null;
}> | null = null;

// Inicializar pool de listeners de forma lazy
export const getListenerPool = () => {
  if (!listenerPool) {
    console.log(`🔧 [heavyInitializations.ts - getListenerPool] Inicializando pool de listeners`, {
      poolSize: LISTENER_POOL_SIZE,
      timestamp: new Date().toISOString()
    });
    listenerPool = [];
    for (let i = 0; i < LISTENER_POOL_SIZE; i++) {
      listenerPool.push({
        id: i,
        isBusy: false,
        assignedDevice: null,
        listener: null
      });
    }
    console.log(`✅ [heavyInitializations.ts - getListenerPool] Pool de listeners inicializado con ${LISTENER_POOL_SIZE} listeners`);
  }
  return listenerPool;
};

// Nota: Los sensores de drag & drop deben inicializarse dentro de componentes React
// usando useSensors hook, por lo que no se pueden exportar como funciones aquí.
// Se mantienen en App.tsx pero solo se inicializan cuando el usuario está autenticado.

